"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _QuestionnaireView_header_accessor_storage, _QuestionnaireView_subheader_accessor_storage, _QuestionnaireView_questionnaire_accessor_storage;
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionnaireView = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const question_type_enum_1 = require("@app/domain/entities/questionnaire/question-type.enum");
require("./questionnaire.styles.css");
let QuestionnaireView = class QuestionnaireView extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        _QuestionnaireView_header_accessor_storage.set(this, '');
        _QuestionnaireView_subheader_accessor_storage.set(this, '');
        _QuestionnaireView_questionnaire_accessor_storage.set(this, void 0);
    }
    get header() { return __classPrivateFieldGet(this, _QuestionnaireView_header_accessor_storage, "f"); }
    set header(value) { __classPrivateFieldSet(this, _QuestionnaireView_header_accessor_storage, value, "f"); }
    get subheader() { return __classPrivateFieldGet(this, _QuestionnaireView_subheader_accessor_storage, "f"); }
    set subheader(value) { __classPrivateFieldSet(this, _QuestionnaireView_subheader_accessor_storage, value, "f"); }
    get questionnaire() { return __classPrivateFieldGet(this, _QuestionnaireView_questionnaire_accessor_storage, "f"); }
    set questionnaire(value) { __classPrivateFieldSet(this, _QuestionnaireView_questionnaire_accessor_storage, value, "f"); }
    createRenderRoot() {
        return this;
    }
    validateQuestionnaire() {
        if (!this.questionnaire) {
            throw new Error('Questionnaire is not defined');
        }
    }
    generateQuestionnaireTemplate() {
        this.validateQuestionnaire();
        return this.generateQuestionAnswerTemplatesFromDefinitions(this.questionnaire.getQuestionAnswerDefinitions(), this.questionnaire.getAssessmentNameAbbreviation(), false, null, this.questionnaire.getQuestionAnswerEntries());
    }
    generateQuestionAnswerTemplatesFromDefinitions(questionAnswerDefinitions, assessmentNameAbbreviation, isChild = false, controlId = null, questionAnswerEntries = []) {
        this.validateQuestionnaire();
        return questionAnswerDefinitions.map((questionAnswerDefinition, index) => {
            if (!controlId) {
                // controlId is null, so we are at the top level
                controlId = `${assessmentNameAbbreviation}-${index}`;
            }
            else {
                // controlId is not null, so we append the index to the control's parent controlId
                controlId = `${controlId}-${index}`;
            }
            questionAnswerDefinition.setControlId(controlId);
            const template = (0, lit_1.html) `
        <div class=${isChild ? 'nested-question' : ''}>
          <div class="questionnaire-question-container">
            ${!isChild ? index + 1 : String.fromCharCode(index + 1 + 64).toLowerCase()}.
            ${questionAnswerDefinition.getQuestionLabel()}
          </div>
          <div>
            ${this.generateAnswerTemplatesFromDefinitions(questionAnswerDefinition.getAnswerDefinitions(), questionAnswerDefinition.getQuestionType(), controlId, this.questionnaire
                .getQuestionAnswerEntries()
                .find((entry) => entry.getQuestionAnswerDefinition() === questionAnswerDefinition))}
          </div>
          ${this.generateQuestionAnswerTemplatesFromDefinitions(questionAnswerDefinition.getChildrenQuestionAnswerDefinitions(), assessmentNameAbbreviation, true, controlId, questionAnswerEntries)}
        </div>
      `;
            controlId = null; // reset controlId for the next iteration
            return template;
        });
    }
    generateAnswerTemplatesFromDefinitions(answerDefinitions, answerType, questionControlId, existingEntry) {
        switch (answerType) {
            case question_type_enum_1.QuestionTypeEnum.TEXT:
                return this.generateTextAnswerTemplate(answerDefinitions, questionControlId, existingEntry?.getAnswerTextEntry());
            case question_type_enum_1.QuestionTypeEnum.NUMBER:
                return this.generateNumberAnswerTemplate(answerDefinitions, questionControlId, existingEntry?.getAnswerNumberEntry());
            case question_type_enum_1.QuestionTypeEnum.RADIO:
                return this.generateRadioAnswerTemplate(answerDefinitions, questionControlId, existingEntry?.getAnswerRadioEntry());
            default:
                return null;
        }
    }
    generateTextAnswerTemplate(answerDefinitions, questionControlId, existingValue) {
        return answerDefinitions.map((answerDefinition) => {
            return (0, lit_1.html) `
        <div>
          <forge-text-field name=${questionControlId} class="questionnaire-answer-text-field">
            <label>${answerDefinition.getAnswerLabel()}</label>
            <input type="text" value=${existingValue ?? ''} />
          </forge-text-field>
        </div>
      `;
        });
    }
    generateNumberAnswerTemplate(answerDefinitions, questionControlId, existingValue) {
        return answerDefinitions.map((answerDefinition) => {
            return (0, lit_1.html) `
        <div>
          <forge-text-field name=${questionControlId} class="questionnaire-answer-text-field">
            <label>${answerDefinition.getAnswerLabel()}</label>
            <input type="number" value=${existingValue ?? ''} />
          </forge-text-field>
        </div>
      `;
        });
    }
    generateRadioAnswerTemplate(answerDefinitions, questionControlId, existingValue) {
        return (0, lit_1.html) `
      <forge-radio-group name=${questionControlId}>
        ${answerDefinitions.map((answerDefinition) => {
            return (0, lit_1.html) `<forge-radio
            .checked=${existingValue !== undefined ? existingValue === answerDefinition.getAnswerValue() : false}
            .value=${answerDefinition.getAnswerValue()}
            name=${questionControlId}
            >${answerDefinition.getAnswerLabel()}</forge-radio
          >`;
        })}
      </forge-radio-group>
    `;
    }
    render() {
        this.validateQuestionnaire();
        return (0, lit_1.html) `
      <forge-card raised>
        ${this.header || this.subheader
            ? (0, lit_1.html) `
              <div>
                <div class="forge-typography--heading4 forge-card-header">${this.header}</div>
                <div class="forge-typography--subheading1">${this.subheader}</div>
              </div>

              <forge-divider class="card-forge-divider"></forge-divider>
            `
            : null}

        <div>${this.generateQuestionnaireTemplate()}</div>
      </forge-card>
    `;
    }
};
exports.QuestionnaireView = QuestionnaireView;
_QuestionnaireView_header_accessor_storage = new WeakMap();
_QuestionnaireView_subheader_accessor_storage = new WeakMap();
_QuestionnaireView_questionnaire_accessor_storage = new WeakMap();
__decorate([
    (0, decorators_js_1.property)({ type: String })
], QuestionnaireView.prototype, "header", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], QuestionnaireView.prototype, "subheader", null);
__decorate([
    (0, decorators_js_1.property)({ type: Object })
], QuestionnaireView.prototype, "questionnaire", null);
exports.QuestionnaireView = QuestionnaireView = __decorate([
    (0, decorators_js_1.customElement)('sup-view-questionnaire')
], QuestionnaireView);
